import { render, staticRenderFns } from "./metadata-modal.vue?vue&type=template&id=5a3e55b2"
import script from "./metadata-modal.vue?vue&type=script&lang=js"
export * from "./metadata-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports